
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 4.5h-5C2.675 4.5 2 5.175 2 6s.675 1.5 1.5 1.5h5c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5z","fill":"#A3A3A3"}})])
          )
        }
      }
    